import React, { Component } from 'react'
import './css/ServiceIcon.css'

class ServiceIcon extends Component {
  render() {
    return (
      <div className="ServiceIcon" id={this.props.icon} >
      </div>
    )
  }
}

export default ServiceIcon
